export const REDIRECT_PATHS = {
  "DEFAULT": '/dashboard',
  "ACTIVE": '/dashboard'
} as const;

type status = keyof typeof REDIRECT_PATHS;

export const getRedirectPath = (status?: string): string => {  
  return REDIRECT_PATHS[status as status] || REDIRECT_PATHS.DEFAULT;
};